import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import vi from './vi.json';
import { storage } from '../lib/storage';

export const locales = [
  { code: 'vi', label: 'Tiếng Việt', enabled: true },
  { code: 'zh-Hans', label: '简体中文', enabled: false },
  { code: 'zh-Hant', label: '繁體中文', enabled: false },
  { code: 'ko', label: '한국어', enabled: false },
  { code: 'ja', label: '日本語', enabled: false },
  { code: 'en', label: 'English', enabled: false },
] as const;
const enabled: string[] = locales.filter(locale => locale.enabled).map(locale => locale.code);
const saved = storage.get('language');
const detected = typeof navigator === 'undefined' ? 'vi' : navigator.language;
void i18n.use(initReactI18next).init({
  resources: { vi: { translation: vi } },
  lng: saved && enabled.includes(saved) ? saved : enabled.includes(detected) ? detected : 'vi',
  fallbackLng: 'vi', supportedLngs: enabled,
  interpolation: { escapeValue: false },
});
export default i18n;
